import React, { FC } from 'react';

const ContentContainer: FC = ({ children }) => {
    return (
        <div className="min-h-full w-full bg-white">
            <div className="max-w-desktop mx-auto p-0 tablet:p-md">
                {children}
            </div>
        </div>
    );
};

export default ContentContainer;
